module.exports = __webpack_public_path__ + "static/media/signature.e65a5afd.jpg";